// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"469a38ec","453":"8945c4db","455":"476d151d","977":"c75db031"}[chunkId] + ".chunk.js";
};